/* Kiomia - ricerca dell'acqua per CAP.
   Quattro livelli, dal piu preciso al meno preciso:
     1. DATI  - il JSON incollato nelle impostazioni della sezione (CAP esatto, area o provincia)
     2. RANGE - intervalli espliciti, per le tre province che condividono le prime tre cifre
     3. AREA  - prefissi a 3 cifre, per le province senza un prefisso a 2 cifre proprio
     4. PROV  - i 93 prefissi a 2 cifre
   I prefissi 49, 68, 69, 77, 78, 79 e 99 non esistono: nessun CAP italiano comincia cosi.
   Fra 00010 e 98168 ogni CAP italiano reale trova sempre una risposta.

   OGNI NUMERO DI QUESTO FILE E' UN DATO LETTO SU UN GESTORE IDRICO.
   Le stime senza fonte della prima versione sono state tolte tutte.

   Ogni voce e' ["Nome della provincia", mg/L, "fonte"].
   Fonte vuota  = il dato e' del gestore di quella provincia (48 province, verificate
                  l'8 agosto 2026, elencate in fondo con gestore e periodo).
   Fonte piena  = per quella provincia il dato del gestore non ce l'abbiamo ancora, e
                  usiamo quello, verificato, della provincia piu vicina. Il nome di
                  quella provincia sta nel terzo campo, la funzione cerca lo restituisce
                  come "fonte", e il quiz lo dice alla cliente invece di nasconderlo.

   Una sostituzione non e' una misura: e' l'ordine di grandezza della zona. Va sempre
   accompagnata dalla riga che dice che il dato e' informativo e che Kiomia non e' il
   referente ufficiale dell'acqua di quel comune. Quando arriva il dato vero di una
   provincia, si sostituisce il valore e si svuota il terzo campo.

   Per il dato comune per comune incolla il JSON dei gestori nel campo
   "Dati comune per comune" della sezione quiz: quello vince su tutto il resto. */
(function(){

  /* 1. Livello provincia - prime due cifre */
  var PROV = {"00":["Roma",288,""],"01":["Viterbo",288,"Roma"],"02":["Rieti",288,"Roma"],"03":["Frosinone",241,""],"04":["Latina",241,"Frosinone"],"05":["Terni",288,"Roma"],"06":["Perugia",195,"Macerata"],"07":["Sassari",90,""],"08":["Nuoro",100,""],"09":["Cagliari",150,""],"10":["Torino",202,"Asti"],"11":["Aosta",244,""],"12":["Cuneo",202,"Asti"],"13":["Vercelli",290,"Alessandria"],"14":["Asti",202,""],"15":["Alessandria",290,""],"16":["Genova",270,"La Spezia"],"17":["Savona",290,"Alessandria"],"18":["Imperia",290,"Alessandria"],"19":["La Spezia",270,""],"20":["Milano",270,""],"21":["Varese",270,"Milano"],"22":["Como",131,"Sondrio"],"23":["Sondrio",131,""],"24":["Bergamo",270,"Milano"],"25":["Brescia",270,"Milano"],"26":["Cremona",261,"Lodi"],"27":["Pavia",130,""],"28":["Novara",130,"Pavia"],"29":["Piacenza",261,"Lodi"],"30":["Venezia",272,""],"31":["Treviso",272,"Venezia"],"32":["Belluno",145,"Bolzano"],"33":["Udine",215,"Pordenone"],"34":["Trieste",180,""],"35":["Padova",220,""],"36":["Vicenza",220,"Padova"],"37":["Verona",220,"Padova"],"38":["Trento",145,"Bolzano"],"39":["Bolzano",145,""],"40":["Bologna",260,""],"41":["Modena",370,""],"42":["Reggio Emilia",370,"Modena"],"43":["Parma",370,"Modena"],"44":["Ferrara",180,""],"45":["Rovigo",220,"Padova"],"46":["Mantova",370,"Modena"],"47":["Forli-Cesena",180,""],"48":["Ravenna",190,""],"50":["Firenze",220,""],"51":["Pistoia",170,""],"52":["Arezzo",220,"Firenze"],"53":["Siena",220,"Firenze"],"54":["Massa-Carrara",270,"La Spezia"],"55":["Lucca",170,"Pistoia"],"56":["Pisa",234,"Livorno"],"57":["Livorno",234,""],"58":["Grosseto",194,""],"59":["Prato",270,""],"60":["Ancona",270,""],"61":["Pesaro e Urbino",270,"Ancona"],"62":["Macerata",195,""],"63":["Ascoli Piceno",140,""],"64":["Teramo",140,"Ascoli Piceno"],"65":["Pescara",128,"L'Aquila"],"66":["Chieti",128,"L'Aquila"],"67":["L'Aquila",128,""],"70":["Bari",190,""],"71":["Foggia",190,""],"72":["Brindisi",180,""],"73":["Lecce",290,""],"74":["Taranto",180,""],"75":["Matera",180,""],"76":["Barletta-Andria-Trani",180,""],"80":["Napoli",256,"Salerno"],"81":["Caserta",241,"Frosinone"],"82":["Benevento",183,"Avellino"],"83":["Avellino",183,""],"84":["Salerno",256,""],"85":["Potenza",190,""],"86":["Campobasso",190,"Foggia"],"87":["Cosenza",190,"Potenza"],"88":["Catanzaro",190,"Potenza"],"89":["Reggio Calabria",270,"Catania"],"90":["Palermo",278,""],"91":["Trapani",278,"Palermo"],"92":["Agrigento",278,"Palermo"],"93":["Caltanissetta",170,""],"94":["Enna",270,"Catania"],"95":["Catania",270,""],"96":["Siracusa",270,"Catania"],"97":["Ragusa",270,"Catania"],"98":["Messina",270,"Catania"]};

  /* 2. Livello area - province senza prefisso proprio a 2 cifre.
     Senza queste righe un CAP di Monza risponderebbe Milano e uno di Rimini risponderebbe Forli. */
  var AREA = {"138":["Biella",202,"Asti"],"139":["Biella",202,"Asti"],"208":["Monza e Brianza",270,"Milano"],"209":["Monza e Brianza",270,"Milano"],"238":["Lecco",131,"Sondrio"],"239":["Lecco",131,"Sondrio"],"268":["Lodi",261,""],"269":["Lodi",261,""],"288":["Verbano-Cusio-Ossola",131,"Sondrio"],"289":["Verbano-Cusio-Ossola",131,"Sondrio"],"478":["Rimini",220,""],"479":["Rimini",220,""],"638":["Fermo",140,""],"639":["Fermo",140,""],"888":["Crotone",190,"Potenza"],"889":["Crotone",190,"Potenza"],"898":["Vibo Valentia",190,"Potenza"],"899":["Vibo Valentia",190,"Potenza"]};

  /* 3. Intervalli - qui la provincia si distingue solo dalla quarta cifra.
     Pordenone, Gorizia e Isernia occupano la fascia 70-99 dentro il prefisso del vicino. */
  var RANGE = [
    [33070, 33099, "Pordenone", 215, ""], [33170, 33170, "Pordenone", 215, ""],   /*V Hydrogea, ago 2023*/
    [34070, 34079, "Gorizia", 298, ""],   [34170, 34170, "Gorizia", 298, ""],     /*V Irisacqua, I sem 2026*/
    [86070, 86097, "Isernia", 241, "Frosinone"], [86170, 86170, "Isernia", 241, "Frosinone"]
  ];

  window.KM_LOOKUP = {
    provincie: PROV,
    aree: AREA,
    intervalli: RANGE,
    /* Restituisce {luogo, mgl, precisione, fonte} oppure null se il prefisso non esiste
       in Italia. fonte e' la provincia da cui viene il numero quando non e' quella
       cercata; stringa vuota quando il dato e' del gestore del posto. */
    cerca: function(cap, extra){
      if (!/^[0-9]{5}$/.test(cap)) return null;
      var chiavi = [ [cap, 'cap'], [cap.slice(0,3), 'area'], [cap.slice(0,2), 'provincia'] ];
      var k, v;

      /* I dati caricati a mano vincono sempre, a qualsiasi livello di precisione. */
      if (extra && typeof extra === 'object') {
        for (k = 0; k < chiavi.length; k++) {
          v = extra[chiavi[k][0]];
          if (v) return { luogo: v[0], mgl: Number(v[1]), precisione: chiavi[k][1], fonte: v[2] || '' };
        }
      }

      var n = parseInt(cap, 10);
      for (k = 0; k < RANGE.length; k++) {
        if (n >= RANGE[k][0] && n <= RANGE[k][1]) {
          return { luogo: RANGE[k][2], mgl: RANGE[k][3], precisione: 'provincia', fonte: RANGE[k][4] || '' };
        }
      }

      v = AREA[chiavi[1][0]];
      if (v) return { luogo: v[0], mgl: Number(v[1]), precisione: 'provincia', fonte: v[2] || '' };

      v = PROV[chiavi[2][0]];
      if (v) return { luogo: v[0], mgl: Number(v[1]), precisione: 'provincia', fonte: v[2] || '' };

      return null;
    }
  };
})();

/* VERIFICATI ALLA FONTE, 8 agosto 2026
   00 Roma                      288 mg/L   Acea Ato2, calcolato da calcio e magnesio, bilancio 2023
   03 Frosinone                 241 mg/L   Acea Ato5, calcolato da calcio e magnesio, bilancio 2023
   07 Sassari                    90 mg/L   Abbanoa, mediana zone Sassari e Gallura, II sem 2025
   08 Nuoro                     100 mg/L   Abbanoa, mediana zone Nuoro e Lanusei, II sem 2025
   09 Cagliari                  150 mg/L   Abbanoa, mediana zone Cagliari, Oristano, Carbonia, Sanluri, II sem 2025
   11 Aosta                     244 mg/L   Comune di Aosta, Servizio Acquedotto, 2013-2020
   14 Asti                      202 mg/L   ASP Asti, gen-giu 2025
   15 Alessandria               290 mg/L   AMAG Reti Idriche, mag 2025
   19 La Spezia                 270 mg/L   ACAM Acque, senza data
   20 Milano                    270 mg/L   MM SpA, senza data
   23 Sondrio                   131 mg/L   SecamAcque, 2024
   27 Pavia                     130 mg/L   Pavia Acque, nov 2021
   30 Venezia                   272 mg/L   Veritas, apr-set 2024
   34 Trieste                   180 mg/L   AcegasApsAmga, media provinciale, 2022
   35 Padova                    220 mg/L   AcegasApsAmga, media provinciale, 2022
   39 Bolzano                   145 mg/L   SEAB Bolzano, 2016
   40 Bologna                   260 mg/L   Hera, 2020 I sem
   41 Modena                    370 mg/L   Hera, 2020 I sem
   44 Ferrara                   180 mg/L   Hera, 2020 I sem
   47 Forli-Cesena              180 mg/L   Hera, 2020 I sem
   48 Ravenna                   190 mg/L   Hera, 2020 I sem
   50 Firenze                   220 mg/L   Publiacqua, 2026 I sem
   51 Pistoia                   170 mg/L   Publiacqua, 2026 I sem
   57 Livorno                   234 mg/L   ASA Livorno, II sem 2021
   58 Grosseto                  194 mg/L   Acquedotto del Fiora, 2016
   59 Prato                     270 mg/L   Publiacqua, 2026 I sem
   60 Ancona                    270 mg/L   Viva Servizi, mar-mag 2026
   62 Macerata                  195 mg/L   APM Macerata, giu 2026
   63 Ascoli Piceno             140 mg/L   CIIP, 2011
   67 L'Aquila                  128 mg/L   Gran Sasso Acqua, nov 2025
   70 Bari                      190 mg/L   AQP, lug-dic 2025
   71 Foggia                    190 mg/L   AQP, lug-dic 2025
   72 Brindisi                  180 mg/L   AQP, lug-dic 2025
   73 Lecce                     290 mg/L   AQP, lug-dic 2025
   74 Taranto                   180 mg/L   AQP, lug-dic 2025
   75 Matera                    180 mg/L   Acquedotto Lucano, set 2024
   76 Barletta-Andria-Trani     180 mg/L   AQP, lug-dic 2025
   83 Avellino                  183 mg/L   Alto Calore Servizi, I sem 2026
   84 Salerno                   256 mg/L   Salerno Sistemi, 2025
   85 Potenza                   190 mg/L   Acquedotto Lucano, 2024
   90 Palermo                   278 mg/L   AMAP, pagina italiana. La pagina inglese dice 325: conteso, senza data
   93 Caltanissetta             170 mg/L   Caltaqua, II trim 2026
   95 Catania                   270 mg/L   SIDRA, II sem 2020
   268 Lodi                     261 mg/L   SAL Lodi, I sem 2026
   269 Lodi                     261 mg/L   SAL Lodi, I sem 2026
   478 Rimini                   220 mg/L   Hera, 2020 I sem
   479 Rimini                   220 mg/L   Hera, 2020 I sem
   638 Fermo                    140 mg/L   CIIP, 2011
   639 Fermo                    140 mg/L   CIIP, 2011
   331/341 Pordenone e Gorizia negli intervalli qui sopra

   PRESE DALLA PROVINCIA VERIFICATA PIU VICINA, in attesa del dato del gestore.
   Il quiz lo dice alla cliente: il numero e' della provincia indicata a destra.
   01 Viterbo                  288 mg/L   dal gestore di Roma
   02 Rieti                    288 mg/L   dal gestore di Roma
   04 Latina                   241 mg/L   dal gestore di Frosinone
   05 Terni                    288 mg/L   dal gestore di Roma
   06 Perugia                  195 mg/L   dal gestore di Macerata
   10 Torino                   202 mg/L   dal gestore di Asti
   12 Cuneo                    202 mg/L   dal gestore di Asti
   13 Vercelli                 290 mg/L   dal gestore di Alessandria
   16 Genova                   270 mg/L   dal gestore di La Spezia
   17 Savona                   290 mg/L   dal gestore di Alessandria
   18 Imperia                  290 mg/L   dal gestore di Alessandria
   21 Varese                   270 mg/L   dal gestore di Milano
   22 Como                     131 mg/L   dal gestore di Sondrio
   24 Bergamo                  270 mg/L   dal gestore di Milano
   25 Brescia                  270 mg/L   dal gestore di Milano
   26 Cremona                  261 mg/L   dal gestore di Lodi
   28 Novara                   130 mg/L   dal gestore di Pavia
   29 Piacenza                 261 mg/L   dal gestore di Lodi
   31 Treviso                  272 mg/L   dal gestore di Venezia
   32 Belluno                  145 mg/L   dal gestore di Bolzano
   33 Udine                    215 mg/L   dal gestore di Pordenone
   36 Vicenza                  220 mg/L   dal gestore di Padova
   37 Verona                   220 mg/L   dal gestore di Padova
   38 Trento                   145 mg/L   dal gestore di Bolzano
   42 Reggio Emilia            370 mg/L   dal gestore di Modena
   43 Parma                    370 mg/L   dal gestore di Modena
   45 Rovigo                   220 mg/L   dal gestore di Padova
   46 Mantova                  370 mg/L   dal gestore di Modena
   52 Arezzo                   220 mg/L   dal gestore di Firenze
   53 Siena                    220 mg/L   dal gestore di Firenze
   54 Massa-Carrara            270 mg/L   dal gestore di La Spezia
   55 Lucca                    170 mg/L   dal gestore di Pistoia
   56 Pisa                     234 mg/L   dal gestore di Livorno
   61 Pesaro e Urbino          270 mg/L   dal gestore di Ancona
   64 Teramo                   140 mg/L   dal gestore di Ascoli Piceno
   65 Pescara                  128 mg/L   dal gestore di L'Aquila
   66 Chieti                   128 mg/L   dal gestore di L'Aquila
   80 Napoli                   256 mg/L   dal gestore di Salerno
   81 Caserta                  241 mg/L   dal gestore di Frosinone
   82 Benevento                183 mg/L   dal gestore di Avellino
   86 Campobasso               190 mg/L   dal gestore di Foggia
   87 Cosenza                  190 mg/L   dal gestore di Potenza
   88 Catanzaro                190 mg/L   dal gestore di Potenza
   89 Reggio Calabria          270 mg/L   dal gestore di Catania
   91 Trapani                  278 mg/L   dal gestore di Palermo
   92 Agrigento                278 mg/L   dal gestore di Palermo
   94 Enna                     270 mg/L   dal gestore di Catania
   96 Siracusa                 270 mg/L   dal gestore di Catania
   97 Ragusa                   270 mg/L   dal gestore di Catania
   98 Messina                  270 mg/L   dal gestore di Catania
   138 Biella                   202 mg/L   dal gestore di Asti
   208 Monza e Brianza          270 mg/L   dal gestore di Milano
   238 Lecco                    131 mg/L   dal gestore di Sondrio
   288 Verbano-Cusio-Ossola     131 mg/L   dal gestore di Sondrio
   888 Crotone                  190 mg/L   dal gestore di Potenza
   898 Vibo Valentia            190 mg/L   dal gestore di Potenza
   86070-86097, 86170 Isernia      241 mg/L   dal gestore di Frosinone
*/
